import sanMartinPoster3 from '../../../assets/san_martin/san_martin_poster_3.png';
import gif1 from '../../../assets/san_martin/gif_1.gif';
import gif2 from '../../../assets/san_martin/gif_2.gif';
import gif3 from '../../../assets/san_martin/gif_3.gif';
import imagen2 from '../../../assets/san_martin/imagen_2.png';

import catervaGif1 from '../../../assets/caterva/2026-07-20_02-33-24__1_.gif';
import catervaControl01 from '../../../assets/caterva/control01.gif';
import catervaMilloTrim from '../../../assets/caterva/millo_trim.gif';
import catervaProyecto from '../../../assets/caterva/proyecto_convertir_a_gif_-_28_de_julio_.gif';
import catervaSleepyEyes from '../../../assets/caterva/sleepy_eyes.gif';

const GAME_ASSET_MAP: Record<string, Record<string, string>> = {
  sanmartin: {
    san_martin_poster_3: sanMartinPoster3,
    gif_1: gif1,
    gif_2: gif2,
    gif_3: gif3,
    imagen2: imagen2,
  },
  caterva: {
    '2026-07-20_02-33-24__1_': catervaGif1,
    control01: catervaControl01,
    millo_trim: catervaMilloTrim,
    'proyecto_convertir_a_gif_-_28_de_julio_de_2026_a_las_11.56.49': catervaProyecto,
    'proyecto_convertir_a_gif_-_28_de_julio_': catervaProyecto,
    sleepy_eyes: catervaSleepyEyes,
  },
};

export function resolveImagePath(src: string, gameId: string): string {
  const match = src.match(/\{STEAM_APP_IMAGE\}\/extras\/(.+)/);

  if (!match) {
    return src;
  }

  const filename = match[1].replace(/\.(png|jpg|jpeg|gif|webp)$/, '');

  const assetMap = GAME_ASSET_MAP[gameId];
  if (!assetMap) {
    return '';
  }

  const resolvedPath = assetMap[filename];
  if (!resolvedPath) {
    return '';
  }

  return resolvedPath;
}

export function registerGameAssets(gameId: string, assets: Record<string, string>): void {
  GAME_ASSET_MAP[gameId] = assets;
}
